module.exports = __webpack_public_path__ + "static/media/SmartAutomation2_CN.1afb76fc.png";